import { render, staticRenderFns } from "./EventLogs.vue?vue&type=template&id=e895077a"
import script from "./EventLogs.vue?vue&type=script&lang=js"
export * from "./EventLogs.vue?vue&type=script&lang=js"
import style0 from "./EventLogs.vue?vue&type=style&index=0&id=e895077a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports